import styled from "styled-components";

export const FABConversas = styled.button`
  background: #0847d6;
  border-radius: 8px;
  color: white;
  position: sticky;
  top: 16px;
  z-index: 2;
  display: grid;
  place-items: center;
  font-size: 14px;
  padding: 8px;
  display: flex;
  gap: 0.5rem;
  float: right;
  margin-bottom: -36px;
`;

export const ClienteInputContainer = styled.div`
  @media (max-width: 575.98px) {
    width: 58%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 80%;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 80%;
  }

  @media (min-width: 992px) and (max-width: 1199.98px) {
    width: 77%;
  }

  @media (min-width: 1200px) {
    width: 80%;
  }
`;

export const AnuncioInputContainer = styled.div`
  width: calc(100% - 58px);
`;

export const ChatTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin-top: 10px;
`;

export const ChatTabsHeader = styled.div`
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
`;

export const ChatTabButton = styled.button<{ active?: boolean }>`
  padding: 10px 15px;
  background: none;
  border: none;
  border-bottom: 2px solid ${props => props.active ? '#5e72e4' : 'transparent'};
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  font-size: 0.95rem;
  color: ${props => props.active ? '#5e72e4' : '#555'};
  font-weight: ${props => props.active ? '600' : 'normal'};
  transition: all 0.2s ease;

  &:hover {
    color: #333;
  }
`;

export const ChatTabContent = styled.div`
  flex: 1;
  display: flex;
  min-height: 50vh;
`;

export const ChatIframe = styled.iframe`
  flex: 1;
  width: 100%;
  height: 60vh;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #f8f9fa;
`;
